import { Spacer } from 'driverama-core/components/spacer/Spacer'
import { ReactNode } from 'react'
import { SNote } from './Note.styled'

import { css } from '@emotion/react'
import { format } from 'date-fns'
import { Dot } from 'driverama-core/components/Dot'
import { TextBody } from 'driverama-core/components/text/Text'
import { color } from 'driverama-core/styles/variables'

import { Flex } from 'driverama-core/components/Flex'

import { parseUTCDate } from 'driverama-core/utils/date'

interface Props {
  children: ReactNode
  createdAt: string
  createdBy?: string
  tag?: ReactNode
  className?: string
}

export function Note(props: Props) {
  return (
    <SNote className={props.className}>
      <Flex variant="row" align="center" gap={2}>
        <TextBody size="small">
          {format(parseUTCDate(props.createdAt), 'dd.MM. HH:mm')}
        </TextBody>
        {props.createdBy && (
          <>
            <Dot />
            <TextBody size="small">{props.createdBy}</TextBody>
            {props.tag}
          </>
        )}
      </Flex>
      <Spacer size={2} />
      <TextBody
        size="small"
        css={css`
          color: ${color('night-d-200')};
        `}
      >
        {props.children}
      </TextBody>
    </SNote>
  )
}
